export const MAP_GEOFENCE_VISIBLE_GEOFENCE_TAGS = "MAP_GEOFENCE_VISIBLE_GEOFENCE_TAGS";
export const MAP_GEOFENCE_VISIBLE_GEOFENCE_TAGS_RESPONSE = "MAP_GEOFENCE_VISIBLE_GEOFENCE_TAGS_RESPONSE";
export const MAP_GEOFENCE_UPDATE_PREFERENCE = "MAP_GEOFENCE_UPDATE_PREFERENCE";